function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import _get from "lodash/get";
import _isPlainObject from "lodash/isPlainObject";
import _merge from "lodash/merge";
import _set from "lodash/set";
import _unset from "lodash/unset";
export var Environment =
/*#__PURE__*/
function () {
  function Environment() {
    _classCallCheck(this, Environment);

    this._currState = {};
  }

  _createClass(Environment, [{
    key: "set",
    value: function set(key, value) {
      if (_isPlainObject(key)) {
        _merge(this._currState, key);
      } else {
        _set(this._currState, key, value);
      }
    }
    /**
     * Gets a value.
     */

  }, {
    key: "get",
    value: function get(keyPath) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return _get(this._currState, keyPath, defaultValue);
    }
    /**
     * Deletes a value
     */

  }, {
    key: "delete",
    value: function _delete(keyPath) {
      _unset(this._currState, keyPath);
    }
    /**
     * Retrives and removes a value
     */

  }, {
    key: "pop",
    value: function pop(keyPath) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var value = this.get(keyPath, defaultValue);
      this.delete(keyPath);
      return value;
    }
    /**
     * Destroys the environment
     */

  }, {
    key: "clear",
    value: function clear() {
      this._currState = {};
    }
    /**
     * Gets the value of a feature or variant
     * Note that this does not actually make a request to Heimdall; the server
     * must have set this value in the view's get_frontend_features function.
     * @param string name The name of the feature to check (eg my_feature)
     */

  }, {
    key: "getFeature",
    value: function getFeature(name) {
      var feature = this.get(["features", name]); // If the feature is undefined or null, return false

      if (feature == null) {
        return false;
      }

      return feature;
    }
  }]);

  return Environment;
}();
var environment = new Environment();
export default environment;

// seed environment with data passed from server
if (window.Lyst) {
  environment.set(window.Lyst.data);
  environment.set(window.Lyst.environment);
}